import React from "react";
import FolderBrowser from "components/folderBrowser/FolderBrowser";
import { useFilter, ContentView } from "hooks/filter";
import { Box, Grid, ToggleButton, ToggleButtonGroup } from "@mui/material";
import GridViewIcon from "@mui/icons-material/GridView";
import ViewListIcon from "@mui/icons-material/ViewList";

export default function Toolbar() {
  const { contentView, setContentView } = useFilter();

  return (
    <Box sx={{ flexGrow: 1 }} mt={4}>
      <Grid
        container
        alignItems="center"
        justifyContent="space-between"
        spacing={2}
      >
        <Grid item>
          <FolderBrowser />
        </Grid>
        <Grid item>
          <Grid container justifyContent="flex-end">
            <ToggleButtonGroup
              color="primary"
              value={contentView}
              exclusive={true}
              size="small"
              onChange={(
                event: React.MouseEvent<HTMLElement>,
                view: ContentView
              ) => {
                if (view !== null) {
                  setContentView(view);
                }
              }}
            >
              <ToggleButton
                size="small"
                disableRipple
                value="grid"
                aria-label="grid"
              >
                <GridViewIcon />
              </ToggleButton>
              <ToggleButton
                size="small"
                disableRipple
                value="list"
                aria-label="list"
              >
                <ViewListIcon />
              </ToggleButton>
            </ToggleButtonGroup>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}
